import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// W3: fail closed to obis-edunexus-production. No demo/suspended-project fallback, no silent degrade.
const EXPECTED_FIREBASE_PROJECT_ID = 'obis-edunexus-production';

function assertProductionFirebaseConfig(cfg: Record<string, string | undefined>): void {
  const required = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
  const missing = required.filter((k) => !cfg[k] || String(cfg[k]).trim() === '');
  const wrongProject = !!cfg.projectId && cfg.projectId !== EXPECTED_FIREBASE_PROJECT_ID;
  if (missing.length === 0 && !wrongProject) return;
  const reason = missing.length
    ? `missing required Firebase config (${missing.join(', ')})`
    : `Firebase projectId "${cfg.projectId}" does not match required "${EXPECTED_FIREBASE_PROJECT_ID}"`;
  const message =
    `OBIS configuration error: ${reason}. Refusing to start — OBIS never falls back to a demo or ` +
    `non-production project. Provide REACT_APP_FIREBASE_* from the production env pointing to ${EXPECTED_FIREBASE_PROJECT_ID}.`;
  if (typeof document !== 'undefined') {
    document.documentElement.innerHTML =
      '<body style="margin:0;font-family:system-ui,Segoe UI,Roboto,sans-serif;background:#0b0b0c;color:#f5f5f5;display:flex;min-height:100vh;align-items:center;justify-content:center">' +
      '<div style="max-width:560px;padding:32px;border:1px solid #5a1d1d;border-radius:12px;background:#1a0f10">' +
      '<h1 style="margin:0 0 12px;font-size:20px;color:#ff6b6b">Configuration error</h1>' +
      `<p style="margin:0 0 8px;line-height:1.5">${reason}.</p>` +
      '<p style="margin:0;opacity:.8;line-height:1.5">OBIS will not connect to a demo or non-production project. Check the production environment configuration.</p>' +
      '</div></body>';
  }
  throw new Error(message);
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

assertProductionFirebaseConfig(firebaseConfig);

// Initialize Firebase only if not already initialized
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
